export const HOME_SIMPLE_PROCESS_SECTION = {
  label: "SIMPLE PROCESS",
  title: "결제부터 발급까지 단 15분",
  description:
    "중요한 것은 물리적 시간이 아니라, 교육 내용과 과정의 적합성입니다",
};

export const HOME_SIMPLE_PROCESS_STEPS = [
  {
    id: "signup",
    number: "01",
    title: "회원가입 및 신청",
    description: "간단한 신청 후 원하는 교육 선택",
  },
  {
    id: "course",
    number: "02",
    title: "교육 수강",
    description: "온라인으로 바로 수강 가능",
  },
  {
    id: "certificate",
    number: "03",
    title: "수료증 발급",
    description: "전체 강의 수강 완료 후 제공",
  },
];
